/**
 * DateFormat：日付＆時刻変換フォーマット
 */
export type DateFormat = (typeof DateFormat)[keyof typeof DateFormat];
export const DateFormat = {
  yyyyMMddHHmmss: 'yyyyMMddHHmmss',
  MMddHHmm: 'MMddHHmm',
  MMdd: 'MMdd',
  HHmm: 'HHmm',
} as const;
